(function (window, document, undefined) {

  'use strict';

  let logger = {},
    storage = {},
    state = {},
    Vue = window.Vue || false,
    widgetData = false;

  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x26BD) + ' [eliteliga][widget]');
  } catch(e) {
    logger = { log: function() {} };
  }

  try {
    state = window.RussMedia.Consent.State;
  } catch(e) {
    state = {
      set: function() {
        return;
      }
    };
  }

  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch(e) {
    storage = {
      get: function() {
        return null;
      },
      set: function() {
        return false;
      },
      remove: function() {
        return;
      }
    };
  }

  /**
   * Initialize.
   * Check if Vue is available, get the widget data
   * and initialize all available widgets.
   *
   * @return {undefined}
   */
  const _init_widgets = function () {

    if (!Vue) {
      logger.log('_init: No Vue!');
      return;
    }

    widgetData = parseWidgetData();
    if (!widgetData) {
      logger.log('_init: No widget data.');
      return;
    }

    let el_widgets = document.getElementsByClassName('vodl-eliteliga-widget');
    if (0 === el_widgets.length) {
      logger.log('_init: No widget.');
      return;
    }

    // Init all widgets.
    Array.from(el_widgets).forEach(el_widget => {
      _init(el_widget);
    });
  };

  /**
   * Initialize each widget.
   *
   * @return {undefined}
   */
  const _init = function (el_widget) {

    logger.log( el_widget );

    let soccerleague = [];
    try {
      soccerleague = widgetData.data.multileague;
    } catch(e) {
      logger.log('widgetData: widgetData.data.soccerleague.upcoming not found', widgetData);
    }

    let wide, onlyOnWeekend, hideOnWeekend;
    wide = el_widget.getAttribute('data-wide') || false;
    onlyOnWeekend = el_widget.getAttribute('data-only-weekends') || false;
    hideOnWeekend = el_widget.getAttribute('data-hide-weekends') || false;
    logger.log("_init(): \n\twide version: " + wide + "\n\tonlyOnWeekend: " + onlyOnWeekend + "\n\thideOnWeekend: " + hideOnWeekend, widgetData);

    const eliteligaWidget = Vue.createApp({
      components: {
        EliteligaWidget: window['@russmedia-frontend/nordstern-eliteliga'].EliteligaWidget,
      },
      setup() {
        function handleOnVideo(data) {

          logger.log('handleOnVideo: data is', data);

          let openEliteligaVideoEvent = new CustomEvent('vodl_open_elite_liga_video', {detail: data});

          // We need to check subscription state first.
          let userStatus = storage.get('user-status') || {};
          if (userStatus && userStatus.hasPlusAccess) {
            // Carry on, show the video.
            logger.log('handleOnVideo: user is plus subscriber', userStatus);
            window.dispatchEvent(openEliteligaVideoEvent);
          } else {
            // Show the paywall.
            let tp = window.tp || false;
            let rmpi = window.RussMedia.Piano || false;
            logger.log('handleOnVideo: user is not plus subscriber', userStatus);
            logger.log('handleOnVideo: tp object:', tp);
            if (tp && rmpi) {
              rmpi.setTags(['plus']);
              tp.push(['setCustomVariable', 'angebot-eliteliga', true]);
              tp.push(['setCustomVariable', 'modalOffer', true]);
              tp.experience.execute();

              waitForCheckoutComplete().then(
                () => {
                  logger.log('handleOnVideo: checkout completed.');
                  // We should remember the state, if users with a fresh subscription try to open another video.
                  state.set('hasPlusAccess', true);
                  window.dispatchEvent(openEliteligaVideoEvent);
                }, (error) => {
                  logger.log('handleOnVideo:', error);
                }
              );
            }
          }
        }

        function handleGotoMediathek(event) {
          switch (event.league) {
            case "Regionalliga West":
              window.location.href = "https://www.vol.at/mediathek-regionalliga";
              return;
          }

          if (!widgetData.mediathek_url) {
            logger.log('handleGotoMediathek: widgetData.mediathek_url not defined.');
            return;
          }
          window.location.href = widgetData.mediathek_url;
        }

        function handleGotoSpecial(event) {
          switch (event.league) {
            case "Regionalliga West":
              window.location.href = "https://www.vol.at/specials/regionalliga";
              return;
          }
                    
          if (!widgetData.special_url) {
            logger.log('handleGotoMediathek: widgetData.special_url not defined.');
            return;
          }
          window.location.href = widgetData.special_url;
        }

        function waitForCheckoutComplete() {
          return new Promise((resolve, reject) => {
            // If the vodl_show_full_content event is triggered,
            // this means the checkout completed and we may resolve().
            document.addEventListener('vodl_show_full_content', function(){
              resolve();
            });

            // If the vodl_piano_checkout_canceled event is triggered,
            // the checkout was canceled, we need to reject().
            document.addEventListener('vodl_piano_checkout_canceled', function(){
              reject('Checkout canceled');
            });

          });
        }

        return {
          soccerleague,
          wide,
          onlyOnWeekend,
          hideOnWeekend,
          handleOnVideo,
          handleGotoMediathek,
          handleGotoSpecial
        };
      }
    }).mount(el_widget);

  };


  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @return {object|boolean} The widget data object on success, false otherwise.
   */
  const parseWidgetData = function() {
    const widgetDataNode = document.querySelector('.vodl-eliteliga-widget script[type="application/json"]');;

    let parsedWidgetData = {};

    try {
      parsedWidgetData = JSON.parse(widgetDataNode.innerHTML) || false;
    }
    catch(e) {
      return false;
    }

    return parsedWidgetData;
  };

  _init_widgets();

})(window, document);
